'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' });

var Error = function Error(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Error = (0, _pure2.default)(Error);
Error.muiName = 'SvgIcon';

exports.default = Error;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Error.js
// module id = 2348
// module chunks = 0